<template>
<v-card style="height:90vh">

<v-toolbar height="42" color="#242F3B" dark flat>
<v-card-title class="ma-0 pa-0">
<span v-if="!init.isCreator" style="font-size:1.4em">   Редактировать -  {{init.bot.name}} </span>
<span v-else style="font-size:1.4em">   Создание нового бота  </span>
</v-card-title>
<v-spacer></v-spacer>
<v-icon  @click="close()"> mdi-close</v-icon>
</v-toolbar>

<v-snackbar v-model="init.sb.snackbar" :color="init.sb.color" center top absolute :timeout="2000">
{{ init.sb.text  }}
<v-btn dark flat @click="init.sb.snackbar = false"> ОК </v-btn>
</v-snackbar>

<v-card-text>

  <v-text-field v-if="!init.isCreator" color="#4A76A8"  v-model="init.bot.name" label="Новое название" clearable></v-text-field>
  <v-text-field v-else color="#4A76A8"  v-model="init.bot.name" label="Название нового бота" clearable></v-text-field>

<div>
<b-card no-body>
<b-tabs   card>

<b-tab>

<template #title>
<v-icon small color="green">mdi-worker</v-icon> <strong style="margin-left:5px">Основное</strong>
</template>



<v-text-field color="#4A76A8"  v-model="init.bot.user_params.token" label="Token бота" clearable></v-text-field>
<v-text-field color="#4A76A8"  v-model="init.bot.user_params.channelId" label="Id канала" clearable></v-text-field>
<v-text-field color="#4A76A8"  v-model="init.bot.user_params.userId" label="Id владельца канала" clearable></v-text-field>


</b-tab>




<b-tab>
<template #title>
<v-icon small color="pink">mdi-alert-circle</v-icon> <strong style="margin-left:5px">Уведомления</strong>
</template>

<v-switch v-model="init.bot.alert_list.is" class="mt-0" color="green" hide-details >
<span style="margin-top:6px" slot="label">Активировать уведомления</span>
</v-switch>
<div  v-if="init.bot.alert_list.is">

<div>
<v-checkbox v-model="init.bot.alert_list.accounts.is" hide-details  color="#232F3A"  >
<span style="color:#232F3A;margin-top:6px" slot="label">Аккаунты</span>
</v-checkbox>
</div>
<div>
<v-checkbox v-model="init.bot.alert_list.tasks.is" hide-details  color="#232F3A"  >
<span style="color:#232F3A;margin-top:6px" slot="label">Действия</span>
</v-checkbox>
</div>
<div>
<v-checkbox v-model="init.bot.alert_list.parser.is" hide-details  color="#232F3A"  >
<span style="color:#232F3A;margin-top:6px" slot="label">Парсер</span>
</v-checkbox>
</div>
<div>
<v-checkbox v-model="init.bot.alert_list.activiti.is" hide-details  color="#232F3A"  >
<span style="color:#232F3A;margin-top:6px" slot="label">Активность</span>
</v-checkbox>
</div>
<div>
<v-checkbox v-model="init.bot.alert_list.antigate.is" hide-details  color="#232F3A"  >
<span style="color:#232F3A;margin-top:6px" slot="label">Антигейт</span>
</v-checkbox>
</div>


</div>
</b-tab>




<b-tab>
<template #title>
<v-icon small color="#273C51">mdi-worker</v-icon> <strong style="margin-left:5px">Автоматические действия</strong>
</template>


</b-tab>



<b-tab>

<template #title>
<v-icon small color="yellow">mdi-tune</v-icon> <strong style="margin-left:5px">Параметы</strong>
</template>

</b-tab>


</b-tabs>
</b-card>
</div>


<v-btn v-if="init.isCreator" style="text-transform:none"   color="#4A76A8"   flat @click="createBot()" block>
<v-icon> mdi-plus </v-icon> <span style="margin-left:5px"> Создать бот </span>
</v-btn>
<v-btn v-else style="text-transform:none"   color="#4A76A8"   flat @click="createBot()" block>
<v-icon>mdi-content-save</v-icon> <span style="margin-left:5px">Сохранить изменения</span>
</v-btn>


</v-card-text>




  </v-card>




</template>

<script>

import axios from 'axios'
export default {
components:{},
props: ['init'],
data () {
return {
}
},
  methods: {
   changeSelectedGr(){
     axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/resources/accounts/accounts_get.php', {
          method: 'get',
          params: {grId:this.creator.newTask.accGroupId},
        }).then(response => {
      this.creator.newTask.accountsAll = response.data.filter((item, i , arr)=>{

      if(item.info.valid == "1"  && item.info.task_able == "1"){
        return true
      } else return false
    })
        })
   },


removeSelectedAccount(item) {
const index = this.creator.newTask.accounts.indexOf(item.id)
if (index >= 0) this.creator.newTask.accounts.splice(index, 1)
},
removeSelectedFilter(item) {

const index = this.creator.filters.selected.indexOf(item)
if (index >= 0) this.creator.filters.selected.splice(index, 1)
},

   messageAct(){

     if( this.creator.newTask.actions.messageSend.activated ){
       this.creator.newTask.actions.messageSend.activated = true
       this.creator.newTask.modals.message = true
     } else  {
       this.creator.newTask.actions.messageSend.activated =  false
     }
   },

close(){
this.$router.go()
},

createBot(){
let params = {}
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/telega/create_bot.php', {
method: 'POST',
data: {isCreator: this.init.isCreator, bot:this.init.bot}
})
.then( response => {
this.$router.go()
})

}



  },
  computed:{

  },
  mounted(){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/resources/accounts/gr_list_get.php', {
contentType: 'JSONP',
method: 'get',
}).then(response => {
this.creator.newTask.accGroupsList = response.data
})

axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/resources/accounts/accounts_get.php', {
method: 'get',
}).then(response => {
this.creator.newTask.accountsAll = response.data.filter((item, i , arr)=>{
if(item.info.valid == "1"  && item.info.task_able == "1"){
return true
} else return false
})
})

axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/get_processes.php', {
method: 'POST',
data: {contentType:'pages'},
}).then(response => {
this.creator.procesess.items = response.data
})

axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/filter/get_list.php', {
method: 'POST',
data: {contentType:'pages'},
}).then(response => {
this.creator.filters.all = response.data
})

  },

}
</script>

<style    >

</style>
